exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content{background-color:#ecf0f5}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/client/styles/webpack_css_fix.css
 ** module id = 57
 ** module chunks = 0
 **/